<template>
  <div class="ao-deal">
    <el-form ref="form" :model="formBuy" label-width="80px">
      <el-form-item :label="$t('deal.chooseType')">
        <el-select v-model="priceType" :placeholder="$t('deal.choose')">
          <!-- 限价方式： 0限价交易  1市价交易 -->
          <el-option :label="$t('deal.tabListRTitle')[0]" value="0"></el-option>
          <el-option :label="$t('deal.tabListRTitle')[1]" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="(mark == 1 ? db_1_txt[1] : db_1_txt[2]) +'('+usdt+')'">
        <el-input
          v-model="formBuy.price"
          :disabled="priceType == '1' ? true : false"
          placeholder=""
          @focus="focus"
          @blur="blur"
          @input="inputPrice"
        >
        </el-input>
      </el-form-item>
      <!-- 合约 倍数 -->
      <el-form-item v-if="type==2" :label="$t('deal.db_2_txt')[1]"  @change="multipleChange">
        <el-select v-model="formBuy.multiple" :placeholder="$t('deal.choose')" :allow-create="true" :filterable="true">
          <el-option v-for="item in list1" :key="item.id" :label="item.value" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="type==1?(mark == 1 ? db_1_txt[3] : db_1_txt[4]):(mark == 1 ? db_1_txt[8] : db_1_txt[9])+'('+currency+')'">
        <el-input v-if="type ==1" v-model="formBuy.amount" type="number" min="0" @input="inputAmount">
        </el-input>
        <!--  onkeyup="this.value=this.value.replace(/\D|^0/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')" -->
        <el-input v-else v-model="formBuy.amount" type="number" min="0" :placeholder=" $t('deal.db_2_txt')[4] + wallet.lot + currency">
        </el-input>
      </el-form-item>
      <!-- <el-form-item v-if="type==2 && priceType == 1">
        <div class="lot el-row" style="line-height: 8px;margin-top:10px">{{ $t('deal.db_2_txt')[4] }} {{ wallet.lot }} {{ currency }}</div>
      </el-form-item> -->

      <!-- <el-form-item label="密码">
        <el-input v-model="formBuy.password" placeholder="请输入交易密码"></el-input>
      </el-form-item>-->
    </el-form>
    <el-slider v-model="formBuy.percentVal" :step="25" show-stops @change="percent" v-show="type == 1"></el-slider>
    <div v-show="type == 1" class="percent-text">{{formBuy.percentVal}}% {{currency}}</div>
    <el-slider v-model="slider" :step="25" show-stops @change="change" v-show="type == 2 && priceType == 1"></el-slider>
    <div v-show="type == 2" class="percent-text">{{slider}}% {{currency}}</div>
    <div class="d" v-if="type==1">
      <div>
        <span class="t">{{ mark==1?$t('deal.dir2')[0]:$t('deal.dir2')[1] }} {{ currency }}:</span>
        <span class="green">{{ type==1&&mark==2?wallet.positions:useNumber }}</span>
      </div>
      <div v-show="mark == 1">
        <!-- 当前余额 -->
        <span class="t">{{ currency }} {{ $t('deal.balance') }}</span>
        <span class="green">{{ wallet.positions }}</span>
      </div>
    </div>
    <div class="d" style="margin-top:5px">
      <div v-show="type == 1">
        <span class="t">{{$t('deal.sxf')}}: {{dealRate}}%</span>
        <span class="green"></span>
      </div>
      <div v-show="type == 1">
        <span class="t">{{$t('deal.jye')}}: {{tradeAccount}}</span>
        <span class="green"></span>
      </div>
    </div>
    <el-button :class="[mark==1?'buy':'sell']" type="primary" @click="event">
      {{ mark ==1 ? tabListLEntrust[0] : tabListLEntrust[1] }} {{ currency }}
    </el-button>
  </div>
</template>


<script>
import { getSetting,getInfo } from '@/api/index'
export default {
  props: {
    usdt: String,
    currency: String,
    mark: Number,
    type:Number,
    price: {
      type: [String, Number],
      default: ""
    },
    xianjia: {
      type: [String, Number],
      default: ""
    },
    setPrice: {
      type: String,
      default: ""
    },
    dealRate: Number,
    wallet: {
      type: Object,
      default:() => {
        return {
          usdt:0,
          usdt_lock:0,
          positions:0,
          positions_lock:0
        }
      }
    }
  },
  computed: {

  },
  watch: {
    currency(v){
      this.formBuy.percentVal = 0;
      this.formBuy.amount = '';
      this.slider = 0;
    },
    mark() {
      this.formBuy.percentVal = 0;
      this.formBuy.amount = '';
    },
    setPrice(a, b) {
      if (a != b && a) {
        this.is_focus = true;
        this.formBuy.price = a;
      }
    },
    type(v){
      this.formBuy.percentVal = 0;
      this.formBuy.amount = '';
      this.slider = 0;
      this.getInfo()
    },
    'formBuy.multiple': {
      handler: function() {
        this.getInfo();
      },
    },
    'formBuy.price': {
      handler: function() {
        if(this.type==1){
          if(this.wallet.usdt && this.formBuy.price){
            this.useNumber = (this.wallet.usdt/this.formBuy.price).toFixed(4);
          }else{
            this.useNumber = 0
          }
        }else{
          if(this.formBuy.multiple && this.wallet.usdt && this.formBuy.price){
            this.useNumber = this.ffff(this.wallet.usdt / (this.formBuy.price - 0 + this.dealRate/100) / this.wallet.lot * this.formBuy.multiple)
          }else{
            this.useNumber = 0;
          }
        }
        // if(this.mark === 1){
        //   this.formBuy.amount = (this.wallet.usdt * this.formBuy.percentVal / (100 * this.formBuy.price)).toFixed(4);
        // }else{
        //   this.formBuy.amount = ((this.wallet.positions * this.formBuy.percentVal) / 100).toFixed(4);
        // }
      },
    },
    price(a, b) {
      if (!b) this.is_focus = false;
      if (!this.is_focus) this.formBuy.price = this.price;
      this.tradeAccount = (this.formBuy.price * this.formBuy.amount).toFixed(4);
    },
    priceType(a, b) {
      if (!b) this.is_focus = false;
      if(this.priceType == 1){
        this.formBuy.price = this.price;
      }
      this.formBuy.amount = 0;
      this.slider = 0
      // if (!this.is_focus)
      //   this.formBuy.price = this.priceType === 0 ? this.price : "";
      //   this.formBuy.amount = 0;
      //   this.slider = 0
    }
  },
  data() {
    var that = this;
    return {
      list1: [
        {
          value : 1
        },
        {
          value : 20
        },
        {
          value : 40
        },
        {
          value : 60
        },
        {
          value : 80
        },
        {
          value : 100
        }
      ],
      list2: [],
      tabListLEntrust: this.$t("deal.tabListLEntrust"), //["买入", "卖出"],
      priceType: '1',
      db_1_txt: this.$t('deal.db_1_txt'), // ['可用', '买入价', '卖出价', '买入量', '卖出量', '交易额', '以市场最优价格买', '以市场最优价格卖'],
      is_focus: false,
      slider: 0,
      total: "0.0000",
      formBuy: {
        price: that.price,
        amount: 0,
        password: "",
        multiple: 0,
        percentVal: 0
      },
      tradeAccount: '',//交易额
      multiple: 0,
      useNumber: '',
      lang: 'en',
    };
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'en';
    getSetting().then(res => {
      let arr1 = [];
      let arr2 = [];
      res.forEach(o => {
        // o.classify==1&&arr1.push(o) // 倍数
        o.classify==2&&arr2.push(o) // 输入手数
      })
      // arr1.sort(function(a,b){
      //   return a.value - b.value
      // })
      arr2.sort(function(a,b){
        return a.value - b.value
      })
      // this.list1 = arr1
      this.list2 = arr2
      this.formBuy.multiple = this.list1[0].value
    })
  },
  methods: {
    getInfo() {
      var data = {
        currency: this.currency,
        type: this.type,
        multiple: this.formBuy.multiple
      };
      getInfo(data).then(res => {
        this.wallet.max_cnt = res.max_cnt;
        var amount = this.slider / 100  * res.max_cnt;
        this.wallet.positions = res.wallet.positions;
        this.formBuy.amount = parseInt(Math.floor((amount).toFixed(4)));
      });
    },
    percent(){
      if(this.mark === 1){
          this.formBuy.amount = (this.wallet.usdt * this.formBuy.percentVal / (100 * this.formBuy.price)).toFixed(4);
      }else{
          this.formBuy.amount = ((this.wallet.positions * this.formBuy.percentVal) / 100).toFixed(4);
      }
    },
    inputPrice() {
      this.slider = 0
      //var price = this.formBuy.price || 0
      //var amount = this.formBuy.amount || 0
      //this.total = this.ffff(price * amount, 4);
    },
    inputAmount() {
      let amount = this.formBuy.amount;
      amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
      amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
      amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
      if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
        amount = parseFloat(amount)
      }
      this.formBuy.amount = amount;
      this.tradeAccount = (this.formBuy.price * this.formBuy.amount).toFixed(4);
      this.inputPrice()
    },
    focus() {
      this.is_focus = true;
    },
    blur() {
      if (!this.formBuy.price) {
        this.is_focus = false;
      }
    },
    multipleChange() {
      this.change();
    },
    change() {
      var price = this.formBuy.price;
      if (this.type === 2) {
        // 合约 买入、卖出
        // var amount = this.slider / 100 * (this.wallet.usdt / (price - 0 + this.dealRate / 100) / this.wallet.lot * this.formBuy.multiple);
        var amount = this.slider / 100  * this.wallet.max_cnt;
        this.formBuy.amount = parseInt(Math.floor((amount).toFixed(4)));
      } else {
        if(this.mark === 1){
          // 币币买入
          // var amount = this.slider / 100 * (this.wallet.usdt / (price - 0 + this.dealRate / 100))
          var amount = (this.wallet.usdt  * this.slider) / (100 * price);
          this.formBuy.amount = (amount).toFixed(4);
        }else{
          // 币币卖出
           this.formBuy.amount = this.ffff((this.slider / 100) * this.wallet.positions, 0);
        }
      }
    },
    ffff(v, l = 4) {
      return Math.floor(v);
      return parseFloat(v).toFixed(0);
    },
    event() {
      this.formBuy.price_type = this.priceType;
      this.formBuy.mark = this.mark;
      this.formBuy.currency = this.currency;
      this.formBuy.percentVal = 0;
      this.$emit("event", this.formBuy);
    }
  }
};
</script>

<style lang="scss">
$background-order-input-color:#f5f5f5;
$green:#4db872;
$red:#ee6560;

.ao-deal {
  .lot{
    font-size: 12px;
    color: #637085;
  }
  .d{
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    span{
      font-size:12px;
      &.t{
        color:#aaa;
      }
    }
  }
  .el-form-item {
    position: relative;
    line-height: 30px;
    margin-top: 4px;
    margin-bottom: 0;
  }

  .el-form-item__label {
    text-align: left;
    padding: 0;
    font-size: 12px;
    color: #637085;
  }
  .el-input__inner {
    border: 1px solid $background-order-input-color;
    border-radius: 3px;
    height: 30px;
    text-indent: 15px;
    font-size: 0.14rem;
    color: #000;
    background-color: $background-order-input-color;
    line-height: 30px;
    padding: 0;
  }
  .el-form-item__label,
  .el-form-item__content{
    line-height: 30px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f5f5;
    color: #2e3753;
    border: 1px solid #2e3753;
    color: 12px;
  }
  .el-input-group__append {
    color: #637085;
    font-size: 16px;
    border: none;
    padding: 0 0 0 8px;
    background: transparent;
  }
  .el-slider__runway {
    background-color: #f5f5f5;
  }
  .el-button {
    width: 100%;
    height: 40px;
    border-radius: 3px;
    color: #000;
    border: none;
    margin-top: 10px;
    font-size: 16px;
    cursor: pointer;
    &.buy {
      background-color: $green;
    }
    &.sell {
      background-color: $red;
    }
  }
  .el-select{
    width:100%;
  }
  .percent-text{
    color: #aaa;
    font-size: 13px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/deal/components/AoDealBox.vue